import { render, staticRenderFns } from "./FacilityInformation.vue?vue&type=template&id=4b9e823e&scoped=true&"
import script from "./FacilityInformation.vue?vue&type=script&lang=js&"
export * from "./FacilityInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9e823e",
  null
  
)

export default component.exports